import React from 'react';
import Typography from '@material-ui/core/Typography';

const ImageGalleryTitle = (props) => {
    return (
        <Typography
            align="left"
            variant="body2"
            style={{ fontSize: 14, color: 'black', padding: 5 }}
        >
            {props.title}
        </Typography>
    );
};

export default ImageGalleryTitle;
